import {useEffect, useState} from 'react';
import {Chart} from 'chart.js/auto';
import {getSpendingDistributionByMainCategory} from "../../../APIs/auditor_dashboard";

const useSpendingByProductMainCategoryPieChart = (chartRef, chartInstanceRef, filters, setLoading) => {
    const [data, setData] = useState({});
    const [dataLoaded, setDataLoaded] = useState(false);

    const fetchSpendingDistributionByProductMainCategory = async () => {
        try {
            setLoading(true);
            const response = await getSpendingDistributionByMainCategory(filters);
            setData(response.data);
            setDataLoaded(true);
        } catch (error) {
            console.error('Error fetching spending by main category:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (chartRef.current) {
            fetchSpendingDistributionByProductMainCategory();
        }
    }, [chartRef, filters]);

    useEffect(() => {
        if (dataLoaded) {
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
            }
            const ctx = chartRef.current.getContext("2d");

            Chart.defaults.font.family = 'IRANSansFaNum';

            const sortedData = Object.entries(data).sort((a, b) => b[1] - a[1]);
            const top10 = sortedData.slice(0, 10);
            const othersSum = sortedData.slice(10).reduce((sum, [, value]) => sum + value, 0);
            let labels = [];
            if (othersSum > 0) {
                labels = [...top10.map(([label]) => label), 'سایر'];
            }
             else {
                labels = [...top10.map(([label]) => label)];
            }
            const chartData = [...top10.map(([, value]) => value), othersSum];

            chartInstanceRef.current = new Chart(ctx, {
                type: 'pie',
                data: {
                    labels: labels,
                    datasets: [{
                        data: chartData,
                    }]
                },
                options: {
                    responsive: true,
                    // maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: true,
                            position: 'bottom',
                            labels: {
                                font: {
                                    size: 14
                                },
                                padding: 15,
                                usePointStyle: true,
                            }
                        },
                        tooltip: {
                            enabled: true,
                            backgroundColor: '#1A237E',
                            titleColor: 'white',
                            bodyColor: 'white',
                            displayColors: false,
                            intersect: false,
                            callbacks: {
                                label: function (tooltipItem) {
                                    const dataset = tooltipItem.chart.data.datasets[0];
                                    const total = dataset.data.reduce((acc, value) => acc + value, 0);
                                    const currentValue = dataset.data[tooltipItem.dataIndex];
                                    const percentage = ((currentValue / total) * 100).toFixed(2);
                                    return `مقدار: ${tooltipItem.formattedValue} (${percentage}%)`;
                                }
                            }
                        },
                    }
                },
            });

            setDataLoaded(false);
        }

    }, [data, dataLoaded, chartRef, chartInstanceRef]);
};

export default useSpendingByProductMainCategoryPieChart;
